import { Component, OnInit, ViewChild, TemplateRef } from "@angular/core";
import { NgbModalConfig, NgbModal, NgbModalOptions, ModalDismissReasons } from "@ng-bootstrap/ng-bootstrap";
import { moveItemInArray } from "@angular/cdk/drag-drop";
import { Router, ActivatedRoute, NavigationEnd, NavigationStart } from "@angular/router";
import { HttpClient } from "@angular/common/http";
import { FormControl, FormsModule, Validators, FormGroup } from "@angular/forms";

import { InvoiceService } from "./../../../_services/invoice.service";
import { DirtyCheckComponent } from "src/app/_models/dirty-check.component";
import { AuthService } from "src/app/_app-core/services/auth/auth.service";
import { DateUtilsService } from "src/app/_services/dateUtils";
import { Config } from "src/app/_store/config";

@Component({
  selector: "app-upload-preview-logistics",
  templateUrl: "./upload-preview-logistics.component.html",
  styleUrls: ["./upload-preview-logistics.component.scss"],
})
export class UploadPreviewLogisticsComponent implements OnInit, DirtyCheckComponent {
  Config = Config;
  docs = [
    {
      docType: "PO2S",
      description: "PO2S",
    },
    {
      docType: "PO2X",
      description: "PO2X",
    },
    {
      docType: "PO2O",
      description: "PO2O",
    },
  ];

  @ViewChild('sizeErrorModal') sizeErrorModal: TemplateRef<any>;
  invoiceDetails: any;
  closeResult: string = "";
  modalOptions: NgbModalOptions;
  loading: boolean = false;
  uploadSuccessful: boolean = false;
  saving: boolean = false;
  uploadInvoice: boolean = false;
  displayName: any;
  hasError: boolean = false;
  imgUrl: string = "";
  typeError: boolean = false;
  sizeError: boolean = false;
  fileTypeError: boolean = false;
  fileSizeError: boolean = false;
  invoiceSaved: boolean = false;
  savingError: boolean = false;
  validationError: boolean = false;
  serverError: boolean = false;
  supportingDocuments: any[] = [];
  agreed = [{ status: false }];
  masterData: any;
  responseData: any;
  isError = false;
  vendorData: any;
  pdfSrc: any;
  invoiceFile: any;
  invoiceDataToSave: any;
  isInvoiceChange: boolean = false;
  isUpdatedData: boolean = false;
  invoiceChanged: boolean = false;
  isCondensed: boolean = false;
  currentLayout = {
    isCondensed: true,
  };
  barcodeNo: any;
  eLoaderMsg = "";
  formSubmitted = false;
  previousUrl: any;
  companies: any;
  organisations: any;
  configResCompanies: any;
  configResOrg: any;
  totalSizeError = false;
  files: File[];
  supportingDocsAdded = false;
  canSubmitForm = false;
  allDeleted = false;
  error: any;

  extractedInvoiceLogistics = new FormGroup({
    invoiceType: new FormControl("e-invoice"),
    file: new FormControl(null),
    supportingFiles: new FormControl([]),
    fileSource: new FormControl(""),
    documentSource: new FormControl(""),
    terms_agreed: new FormControl(false),
    emailAddress: new FormControl(null, [Validators.email, Validators.pattern("^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\\.[a-zA-Z]{2,4}$")]),
    poNo: new FormControl(null, [Validators.pattern("^[0-9]*$"), Validators.minLength(10), Validators.maxLength(10)]),
    username: new FormControl(""),
    userID: new FormControl(""),
    companyCode: new FormControl(null, [Validators.required]),
    purchaseOrg: new FormControl(null, [Validators.required]),
    docType: new FormControl(null, [Validators.required]),
  });

  constructor(
    private modalService: NgbModal,
    private router: Router,
    private route: ActivatedRoute,
    private http: HttpClient,
    private invoiceService: InvoiceService,
    private authService: AuthService,
    private dateUtils: DateUtilsService
  ) {
    this.modalOptions = {
      backdrop: "static",
      backdropClass: "customBackdrop",
      scrollable: true,
    };

    this.router.events.subscribe((val) => {
      if (val instanceof NavigationStart) {
        this.previousUrl = val.url;
      }
    });
  }

  canDeactivate() {
    if (!this.formSubmitted) {
      this.loading = true;
      return false;
    } else {
      return true;
    }
  }

  exitForm() {
    this.loading = false;
    this.formSubmitted = true;
    this.previousUrl = this.route.snapshot.queryParams["returnUrl"] || "dashboard";
    this.router.navigateByUrl(this.previousUrl);
  }

  cancelExit() {
    this.loading = false;
  }

  toggleSidebar() {
    this.currentLayout.isCondensed = !this.currentLayout.isCondensed;
    document.body.setAttribute("data-sidebar-size", this.currentLayout.isCondensed ? "condensed" : "default");
  }

  selectDocuments(event: any) {
    const ALLOWED_TYPES = ["application/pdf"];

    this.files = Array.from(event);
    const totalSize = this.files.reduce((sum, file) => sum + file.size, 0);

    if (totalSize > Config.maxTotalSupportingDocsSize) {
      this.totalSizeError = true;
      this.sizeError = false;
      this.typeError = false;
      this.modalService.open(this.sizeErrorModal, this.modalOptions);
    }

    for (const file of this.files) {
      if (file.size > Config.maxFileSize) {
        this.sizeError = true;
        this.typeError = false;
        this.totalSizeError = false;
        continue;
      }

      if (!ALLOWED_TYPES.includes(file.type)) {
        this.typeError = true;
        this.sizeError = false;
        this.totalSizeError = false;
        continue;
      }
      this.supportingDocuments.push(file);
    }

    if (this.allDeleted === true) {
      if (this.extractedInvoiceLogistics.get("terms_agreed").value === true) {
        this.extractedInvoiceLogistics.patchValue({
          terms_agreed: false,
        });
      }
    } else {
      this.extractedInvoiceLogistics.patchValue({ terms_agreed: false });
    }

    this.supportingDocsAdded = true;
  }

  /**
   * Delete file from files list
   * @param index (File index)
   */
  deleteFile(index: number) {
    this.supportingDocuments.splice(index, 1);
    this.recomputeFileErrors();

    if (this.supportingDocuments.length === 0) {
      if (this.extractedInvoiceLogistics.get("terms_agreed").value === true) {
        this.extractedInvoiceLogistics.patchValue({
          terms_agreed: false,
        });
      }

      this.canSubmitForm = false;
      this.allDeleted = true;
      this.supportingDocsAdded = false;
    }
  }

  checkSupportingDocuments() {
    if (this.supportingDocuments.length > 0 && this.extractedInvoiceLogistics.get("terms_agreed").value === false) {
      this.canSubmitForm = true;
    } else {
      this.canSubmitForm = false;
    }
  }

  private recomputeFileErrors() {
    const totalSize = this.supportingDocuments.reduce((sum, f) => sum + (f.size || 0), 0);
    if (totalSize <= Config.maxTotalSupportingDocsSize) this.totalSizeError = false;
    this.sizeError = false;
    this.typeError = false;
  }

  onDrop(event: any) {
    moveItemInArray(this.supportingDocuments, event.previousIndex, event.currentIndex);
    this.supportingDocsAdded = true;
  }

  reUploadInvoice(event: any) {
    if (event.length > 0) {
      const fileUploaded = event[0];

      if (fileUploaded.type !== "application/pdf") {
        this.hasError = false;
        this.fileSizeError = false;
        this.fileTypeError = true;
      } else if (fileUploaded.size > Config.maxFileSize) {
        this.fileTypeError = false;
        this.hasError = false;
        this.fileSizeError = true;
        this.modalService.open(this.sizeErrorModal, this.modalOptions);
      } else {
        this.fileSizeError = false;
        this.fileTypeError = false;

        if (typeof FileReader !== "undefined") {
          let reader = new FileReader();
          reader.onload = (e: any) => {
            this.pdfSrc = e.target.result;
          };
          let $file: any = fileUploaded;
          reader.readAsArrayBuffer($file);
        }

        this.extractedInvoiceLogistics.patchValue({
          fileSource: fileUploaded,
        });

        this.hasError = false;
        this.isInvoiceChange = true;

        let userId = this.invoiceService.getUserId();
        let username = this.invoiceService.getUsername();

        const userData = {
          req: {
            emailAddress: this.extractedInvoiceLogistics.value.emailAddress,
            companyCode: this.extractedInvoiceLogistics.value.companyCode,
            purchaseOrg: this.extractedInvoiceLogistics.value.purchaseOrg,
            docType: this.extractedInvoiceLogistics.value.docType,
            poNo: this.extractedInvoiceLogistics.value.poNo,
            username: username,
            userId: userId,
            items: [{ poNo: "", itemNo: "", grn: "" }],
          },
        };

        this.loading = true;
        this.invoiceChanged = true;
        this.formSubmitted = true;

        const formData: any = new FormData();
        formData.append("sellerCode", localStorage.getItem("vendorCode"));
        formData.append("sessionId", localStorage.getItem("eippSession"));
        formData.append("invoiceType", "e-invoice");
        formData.append("req", JSON.stringify(userData.req));
        formData.append("file", this.extractedInvoiceLogistics.value.fileSource);

        this.eLoaderMsg = "Verifying QR Code";

        setTimeout(() => {
          this.eLoaderMsg = "Authenticating QR Code";
        }, 5000);
        setTimeout(() => {
          this.eLoaderMsg = "Extracting Data";
        }, 10000);
        setTimeout(() => {
          this.eLoaderMsg = "Validating Data";
        }, 15000);

        this.invoiceService.extractInvoice(formData).subscribe(
          (res) => {
            this.loading = false;
            this.invoiceChanged = false;
            this.isUpdatedData = true;
            this.responseData = res;
            this.formSubmitted = false;
            if (this.responseData.length !== 0 && this.responseData.status === "error") {
              console.error(this.responseData.message);
            } else {
              this.invoiceDetails = this.responseData;
            }
          },
          (error) => {
            console.error(error);
          }
        );
      }
    }
  }

  open(content: any) {
    this.modalService.open(content, this.modalOptions).result.then(
      (result) => {
        this.closeResult = `Closed with: ${result}`;
      },
      (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      }
    );
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return "by pressing ESC";
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return "by clicking on a backdrop";
    } else {
      return `with: ${reason}`;
    }
  }

  saveUploadData() {
    this.loading = true;
    this.saving = true;

    const invoiceData = {
      sellerCode: localStorage.getItem("vendorCode"),
      session: { sessionId: localStorage.getItem("eippSession") },
      data: {
        irn: this.invoiceDetails.irn,
        invoice_number: this.invoiceDetails.invoice_number,
        file_link: this.invoiceDetails.file_link,
        gstin: this.invoiceDetails.gstin,
        invoice_date: this.invoiceDetails.invoice_date,
        invoice_amount: this.invoiceDetails.invoice_amount,
        terms_agreed: false,
        errors: [],
        supporting_docs: this.invoiceDetails.supporting_docs,
        emailAddress: this.extractedInvoiceLogistics.value.emailAddress,
        poNo: this.extractedInvoiceLogistics.value.poNo,
        companyCode: this.extractedInvoiceLogistics.value.companyCode,
        purchaseOrg: this.extractedInvoiceLogistics.value.purchaseOrg,
        docType: this.extractedInvoiceLogistics.value.docType,
        items: this.invoiceDetails.items,
      },
    };

    this.invoiceService.uploadInvoice(invoiceData).subscribe(
      (res) => {
        this.responseData = res;
        if (this.responseData.status == "successful") {
          this.saving = false;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.savingError = false;
          this.serverError = false;
          this.hasError = false;
          this.invoiceSaved = true;
        } else {
          this.saving = false;
          this.invoiceSaved = false;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.hasError = false;
          this.serverError = false;
          this.savingError = true;
        }

      },
      (error) => {
        this.saving = false;
        this.invoiceSaved = false;
        this.uploadInvoice = false;
        this.uploadSuccessful = false;
        this.serverError = false;
        this.savingError = true;
        console.error(error);
      }
    );
  }

  onSubmit() {
    this.loading = true;

    this.uploadInvoice = true;
    this.formSubmitted = true;
    this.hasError = false;

    const trimNo = this.invoiceDetails.invoice_number.replace(/\s+/g, "");

    // Get current user session data
    const currentUser = this.authService.getCurrentUser();
    const session = currentUser.eippSessionData.data.session;

    // Create ledger structure matching curl format
    const timestamp = Date.now();
    const ledger = [
      {
        docDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueDate: this.dateUtils.formatDateString(this.invoiceDetails.invoice_date),
        dueAmt: parseFloat(this.invoiceDetails.invoice_amount),
        docAmt: parseFloat(this.invoiceDetails.invoice_amount),
        docType: "APINV",
        poNo: this.extractedInvoiceLogistics.value.poNo || "",
        docNo: trimNo,
        timestamp: timestamp,
        currCode: "INR",
        status: "PENDING_SUBMISSION",
        supplierNm: localStorage.getItem("displayName"),
        docDetail: {
          docAmt: this.invoiceDetails.invoice_amount,
          docFormat: this.invoiceService.getInvType() || "e-invoice",
          docCat: "logistics",
          docGstin: this.invoiceDetails.gstin,
          irn: this.invoiceDetails.irn,
          barcodePrefix: this.invoiceDetails.barcodePrefix,
        },
        docRef: [
          {
            src: this.invoiceDetails.file_link || this.invoiceDetails.data?.meta?.src || "",
          },
        ],
        lineItemDetail: [],
        supplierCode: localStorage.getItem("vendorCode"),
        cmpCode: this.invoiceDetails.cmpCode || this.invoiceDetails.company_code,
        purchaseOrg: this.invoiceDetails.purchaseOrg || this.invoiceDetails.purchase_org,
        erpDocType: this.invoiceDetails.erpDocType || this.invoiceDetails.doc_type,
        email: this.invoiceDetails.email_address,
      },
    ];

    const formData: any = new FormData();
    formData.append("sellerCode", this.authService.getSellerCode());
    formData.append("reqType", "payexap");
    formData.append("session", JSON.stringify(session));
    formData.append("action", "add");
    formData.append("ledger", JSON.stringify(ledger));

    if (this.supportingDocuments.length !== 0) {
      for (let i = 0; i < this.supportingDocuments.length; i++) {
        formData.append("supportingDocs", this.supportingDocuments[i]);
      }
    } else {
      formData.append("supportingDocs", this.supportingDocuments);
    }

    if (!this.saving) {
      this.invoiceService.uploadInvoiceWithoutExtration(formData).subscribe(
        (res) => {
          this.responseData = res;
          if (this.responseData.status === "error") {
            this.loading = false;
            this.uploadInvoice = false;
            this.hasError = true;
            this.formSubmitted = false;
          } else {
            this.barcodeNo = this.responseData.barcode;
            this.uploadSuccessful = true;
            this.uploadInvoice = false;
          }
        },
        (error) => {
          console.error(error);
          this.loading = false;
          this.error = error.error.message;
          this.uploadInvoice = false;
          this.uploadSuccessful = false;
          this.invoiceSaved = false;
          this.serverError = true;
        }
      );
    }

    this.modalService.dismissAll();
  }

  fetchPurchaseOrg() {
    const configReq = {
      type: "purchaseOrganizations",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResOrg = res;
        if (this.configResOrg.length !== 0 && this.configResOrg.status === "error") {
        } else {
          this.organisations = this.configResOrg.data;
          // Patch purchaseOrg after organisations are loaded
          if (this.invoiceDetails && this.invoiceDetails.purchase_org) {
            this.extractedInvoiceLogistics.patchValue({
              purchaseOrg: this.invoiceDetails.purchase_org,
            });
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  fetchCompanyCode() {
    const configReq = {
      type: "companyCodes",
    };

    this.invoiceService.getConfig(configReq).subscribe(
      (res) => {
        this.configResCompanies = res;
        if (this.configResCompanies.length !== 0 && this.configResCompanies.status === "error") {
          console.error(this.configResCompanies + " Error");
        } else {
          this.companies = this.configResCompanies.data;
          // Patch companyCode after companies are loaded
          if (this.invoiceDetails && this.invoiceDetails.company_code) {
            this.extractedInvoiceLogistics.patchValue({
              companyCode: parseInt(this.invoiceDetails.company_code),
            });
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
  }

  ngOnInit(): void {
    this.displayName = localStorage.getItem("displayName");
    this.invoiceDetails = this.invoiceService.getProcessedInvoice();
    this.formSubmitted = false;

    this.fetchCompanyCode();
    this.fetchPurchaseOrg();

    // Patch values that don't depend on async data
    this.extractedInvoiceLogistics.patchValue({
      purchaseOrg: this.invoiceDetails.purchaseOrg,
      docType: this.invoiceDetails.erpDocType,
      emailAddress: this.invoiceDetails.email_address.toLowerCase(),
      companyCode: parseInt(this.invoiceDetails.cmpCode),
      username: this.invoiceService.getUsername(),
      userID: this.invoiceService.getUserId(),
      poNo: this.invoiceDetails.poNo,
    });

    this.loadFile();
  }

  closeSuccessDialog() {
    this.loading = false;
    this.router.navigateByUrl("/invoices");
  }

  closeErrorDialog() {
    this.loading = false;
    this.savingError = false;
    this.serverError = false;
  }

  resubmitInvoice() {
    this.router.navigateByUrl("/submit-logistics");
  }

  onCheckboxChange(e: any) {
    if (e.target.checked) {
      this.extractedInvoiceLogistics.patchValue({
        terms_agreed: e.target.value,
      });
    } else {
      this.extractedInvoiceLogistics.patchValue({
        terms_agreed: null,
      });
    }
  }

  loadFile() {
    if (typeof FileReader !== "undefined") {
      let reader = new FileReader();
      reader.onload = (e: any) => {
        this.pdfSrc = e.target.result;
      };
      let $file: any = this.invoiceService.getFileElement();
      reader.readAsArrayBuffer($file);
    }

  }

  viewSavedInvoices() {
    this.router.navigate(["/saved-invoices"]);
  }
}
